import React, {useState} from 'react';
import questionareStyle from '../../style';

export default function Slide7(props) {
	let style = questionareStyle();
	let [email, setEmail] = useState(null);

	return (
		<div style={style.ageInputContainer()}>
			<p
				style={{
					...{
						marginTop: '1rem',
					},
					...style.questionareText(),
				}}
			>
				What is your email address?
			</p>
			<input className={'mt-3'} placeholder={'johnthompson@gmail.com'} type='email' onChange={updatedEmail} />
			<button
				style={style.nextButton()}
				onClick={() => {
					if (!emailPasses(email)) {
						alert('Please enter a valid email');
						return;
					}
					props.nextPressed({
						email: email,
					});
				}}
			>
				Next
			</button>
		</div>
	);

	function emailPasses(email) {
		if (!email) return false;
		if (email.indexOf('@') < 0) return false;
		if (email.split('@')[1].length < 1) return false;
		return true;
	}

	function updatedEmail(e) {
		let value = e.target.value;
		setEmail(value);
	}
}
